module.exports = __webpack_public_path__ + "static/media/ic_searchtype_bridge.f70d424d.svg";